import { useTrackPublicPageEvents } from "../misc/useTrackPublicPageEvents";

export enum OrderType {
  STANDARD = "Standard",
  STANDARD_GIFT = "Standard Gift",
  PERSONALIZED_GIFT = "Personalized Gift",
}

export enum EventType {
  BUY_AS_STANDARD_GIFT_CLICKED = "Buy As Standard Gift Clicked",
  EMAIL_GIFT_BUILDER_OPENED = "Email Gift Builder Opened",
  CHECKOUT_INITIATED = "Checkout Initiated",
  ORDER_COMPLETED = "Order Completed",
  CLIENT_SUGGESTED_PACKAGE_CLICKED = "Client Suggested Package Clicked",
}

export enum OnlineStoreSource {
  CONFIRMATION_PAGE = "confirmation_page",
  ONLINE_STORE = "online_store",
  CLIENT_PAGE = "client_page",
}

export const useOnlineStoreMixpanelEvents = (medspaId: string) => {
  return useTrackPublicPageEvents<EventType>(medspaId);
};
